import { z } from 'zod';

export const pageMetaSchema = z.object({
  page: z.number().int(),
  perPage: z.number().int(),
  total: z.number().int(),
  sort: z.string(),
  direction: z.enum(['asc', 'desc']),
});

export type PageMeta = z.infer<typeof pageMetaSchema>;

export function pageSchema<Row extends z.ZodType>(row: Row) {
  return z.object({
    data: z.array(row),
    meta: pageMetaSchema,
  });
}

export interface PageResult<T> {
  data: T[];
  meta: PageMeta;
}

export function parsePage<T>(payload: unknown, row: z.ZodType<T>, label: string): PageResult<T> {
  const parsed = pageSchema(row).safeParse(payload);
  if (!parsed.success) throw new Error(`${label} could not be read.`);
  return parsed.data;
}

export function listPath(path: string, params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === '' || value === 'all' || value === 'All') continue;
    search.set(key, String(value));
  }
  const query = search.toString();
  return query === '' ? path : `${path}?${query}`;
}
